import { journalsServiceApi } from "@entities/api";

interface ICreateSectionFourRecord {
  sectionFourId: string;
  sectionFourRequest: {
    mainJournalId: string;
    section4Id: string;
    section4ListId: string;
    itemPartOne: {
      isDefects: boolean;
      constructionControlInfo: string;
      controlEventPeriod: {
        beginDate: string;
        endDate: string;
      };
      defectsAbsenceRecord: string;
      defectRecordDate?: string;
      defectFixingPlanDate?: string;
      defectDescriptionText?: string;
      docs?: Array<any>;
      works?: Array<any>;
      otherDocuments?: Array<any>;
      structuralElementName?: string;
      locationDescription?: string;
      locationType?: string;
      inspectionEmployeeId: string;
    };
  };
}

export async function createSectionFourRecord({
  sectionFourId,
  sectionFourRequest,
}: ICreateSectionFourRecord) {
  const formData = new FormData();

  formData.append(
    "sectionFourRequest",
    new Blob([JSON.stringify(sectionFourRequest)], {
      type: "application/json",
    }),
  );

  sectionFourRequest.itemPartOne.otherDocuments?.forEach((doc: any) => {
    if (doc.file) {
      formData.append("otherFiles", doc.file);
    }
  });

  const response = await journalsServiceApi.postForm(
    `/journals/section-four/${sectionFourId}`,
    formData,
  );

  return response.data;
}
